
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2CStatewiseGstReportSummaryDialog extends Serenity.EntityDialog<B2CStatewiseGstReportSummaryRow, any> {
        protected getFormKey() { return B2CStatewiseGstReportSummaryForm.formKey; }
        protected getIdProperty() { return B2CStatewiseGstReportSummaryRow.idProperty; }
        protected getLocalTextPrefix() { return B2CStatewiseGstReportSummaryRow.localTextPrefix; }
        protected getNameProperty() { return B2CStatewiseGstReportSummaryRow.nameProperty; }
        protected getService() { return B2CStatewiseGstReportSummaryService.baseUrl; }
        protected getDeletePermission() { return B2CStatewiseGstReportSummaryRow.deletePermission; }
        protected getInsertPermission() { return B2CStatewiseGstReportSummaryRow.insertPermission; }
        protected getUpdatePermission() { return B2CStatewiseGstReportSummaryRow.updatePermission; }

        protected form = new B2CStatewiseGstReportSummaryForm(this.idPrefix);

    }
}